export default "__VITE_ASSET__CrPknjNg__"